import { OptionsWithoutBackground } from "src/routes/onboarding/shared/components/optionsWithoutBackground";
import background from "./bg.png";

const data = [
  {
    displayValue: "Lose 1-10 lbs",
    value: "LOSE_WEIGHT",
  },
  {
    value: "MAINTAIN_WEIGHT",
    displayValue: "Lose 11-20 lbs",
  },
  {
    value: "MAINTAIN_WEIGHT",
    displayValue: "Lose over 20 lbs",
  },
    {
    value: "MAINTAIN_WEIGHT",
    displayValue: "I haven’t decided yet",
  }
];

export const MainGoal = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    onNextStep?.();
    onTrackEvent?.(v.displayValue);
    localStorage.setItem("mainGoal", v.value);
  };
  return (
    <OptionsWithoutBackground
      isWalky={true}
      data={data}
      title="What is your weight goal?"
      onClick={handleNextStep}
      background={background}
    />
  );
};
